<template>
  <b-container class="authPages">
    <b-row>
      <b-col lg="8" offset-lg="2">
        <article class="single-blog contact-us">
          <div class="post-content">
            <div>
              <h3 class="mt-2">Registration</h3>

              <b-alert variant="danger" :show="error.length > 0"
                >{{ error }}
              </b-alert>

              <b-form
                class="form-horizontal contact-form"
                @submit.prevent="register"
              >
                <b-form-group>
                  <b-input
                    v-model.trim="firstName"
                    type="text"
                    id="firstName"
                    name="firstName"
                    placeholder="First Name"
                    required=""
                  />

                  <div v-if="$v.firstName.$dirty">
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.firstName.required"
                    >
                      The field "First Name" cannot be blank.
                    </b-alert>
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.firstName.minLength"
                    >
                      The field "Ime" must contain at least
                      {{ $v.firstName.$params.minLength.min }} letters.
                    </b-alert>
                  </div>
                </b-form-group>
                <b-form-group>
                  <b-input
                    v-model.trim="lastName"
                    type="text"
                    id="lastName"
                    name="lastName"
                    placeholder="Priimek"
                    required=""
                  />

                  <div v-if="$v.lastName.$dirty">
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.lastName.required"
                    >
                      The field "Last Name" cannot be blank.
                    </b-alert>
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.lastName.minLength"
                    >
                      The field "Last Name" must contain at least
                      {{ $v.lastName.$params.minLength.min }} letters.
                    </b-alert>
                  </div>
                </b-form-group>
                <b-form-group>
                  <b-input
                    v-model.trim="displayName"
                    type="text"
                    id="displayName"
                    name="displayName"
                    placeholder="Display Name (this name will be shown next to your posts)"
                    required=""
                  />

                  <div v-if="$v.displayName.$dirty">
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.displayName.required"
                    >
                      The field "Display name" cannot be blank.
                    </b-alert>
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.displayName.minLength"
                    >
                      The field "Display name" must contain at least
                      {{ $v.displayName.$params.minLength.min }} letters.
                    </b-alert>
                  </div>
                </b-form-group>
                <b-form-group>
                  <b-input
                    v-model.trim="yearOfBirth"
                    type="number"
                    step="1"
                    min="1900"
                    :max="moment().format('YYYY')"
                    id="yearOfBirth"
                    name="yearOfBirth"
                    placeholder="Year of Birth (eg. 1970)"
                    required=""
                    @blur="calculateAge"
                  />
                  <div v-if="$v.yearOfBirth.$dirty">
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.yearOfBirth.required"
                    >
                      The field "Year of Birth" cannot be blank.
                    </b-alert>
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.yearOfBirth.numeric"
                    >
                      The field "Year of Birth" can contain only numbers.
                    </b-alert>
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.yearOfBirth.minValue"
                    >
                      The field "Year of Birth" should be after
                      {{ $v.yearOfBirth.$params.minValue.min }}.
                    </b-alert>
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.yearOfBirth.maxValue"
                    >
                      The field "Year of Birth" cannot be after
                      {{ $v.yearOfBirth.$params.maxValue.max }}.
                    </b-alert>
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.yearOfBirth.minLength"
                    >
                      The field "Year of Birth" must contain at least
                      {{ $v.yearOfBirth.$params.minLength.min }} numbers.
                    </b-alert>
                  </div>
                </b-form-group>
                <b-card
                  class="my-3"
                  style="border-radius: 20px;"
                  v-if="isMinor"
                >
                  <b-alert show variant="info"
                    >Minors are legally obliged to register
                    to provide information about their parent or guardian.
                  </b-alert>
                  <b-form-group>
                    <b-input
                      v-model.trim="parentsName"
                      type="text"
                      id="parentsName"
                      name="parentsName"
                      placeholder="Parents'/guardians' first and last name"
                      required=""
                    />
                    <div v-if="$v.parentsName.$dirty">
                      <b-alert
                        show
                        variant="danger"
                        class="error col mt-1"
                        v-if="!$v.parentsName.required"
                      >
                        The field "Parents'/guardians' first and last name" cannot be blank.
                      </b-alert>
                    </div>
                  </b-form-group>

                  <b-form-group class="mb-0">
                    <b-input
                      v-model="parentsEmail"
                      type="email"
                      id="parentsEmail"
                      name="parentsEmail"
                      placeholder="Parents'/guardians' email"
                      required=""
                    />
                    <div v-if="$v.parentsEmail.$dirty">
                      <b-alert
                        show
                        variant="danger"
                        class="error col mt-1"
                        v-if="!$v.parentsEmail.required"
                      >
                        The field "Parents'/guardians' email" cannot be blank.
                      </b-alert>
                      <b-alert
                        show
                        variant="danger"
                        class="error col mt-1"
                        v-if="!$v.parentsEmail.email"
                      >
                        The field "Parents'/guardians' email" should be a valid e-mail address (eg.: firstname.lastname@gmail.com).
                      </b-alert>
                    </div>
                  </b-form-group>
                </b-card>
                <b-form-group>
                  <b-input
                    v-model="phone"
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="phone number (field is not required)"
                  />
                </b-form-group>
                <b-form-group>
                  <b-input
                    v-model="email"
                    type="email"
                    id="email"
                    name="email"
                    placeholder="email"
                    required=""
                  />
                  <div v-if="$v.email.$dirty">
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.email.required"
                    >
                      The field "Email" cannot be blank.
                    </b-alert>
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.email.email"
                    >
                      The field "Email" should be a valid e-mail address (eg.: firstname.lastname@gmail.com).
                    </b-alert>
                  </div>
                </b-form-group>
                <b-form-group>
                  <b-input
                    v-model="password"
                    type="password"
                    id="password"
                    name="password"
                    placeholder="password"
                    required=""
                  />
                  <password v-model="password" :strength-meter-only="true" />

                  <div v-if="$v.password.$dirty">
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.password.required"
                    >
                      The field "Password" cannot be blank.
                    </b-alert>
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.password.minLength"
                    >
                      The field "Password" must contain at least
                      {{ $v.password.$params.minLength.min }} characters.
                    </b-alert>
                  </div>
                </b-form-group>
                <b-form-group>
                  <b-input
                    v-model="passwordRepeat"
                    type="password"
                    id="passwordRepeat"
                    name="passwordRepeat"
                    placeholder="password repeat"
                    required=""
                  />
                  <div v-if="$v.passwordRepeat.$dirty">
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.passwordRepeat.sameAsPassword"
                    >
                      The field "password repeat" must contain same value as field "Password".
                    </b-alert>
                  </div>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox
                    class="mb-3 mt-2"
                    id="termsAndConditionsAcceptance"
                    v-model="termsAndConditionsAcceptance"
                    name="termsAndConditionsAcceptance"
                  >
                    I consent to the
                    <router-link
                      :to="{ name: 'EN_TermsAndConditions' }"
                      target="_blank"
                      active-class="active"
                      exact
                      >Terms of Use and Privacy Policy
                    </router-link>
                  </b-form-checkbox>

                  <div v-if="$v.termsAndConditionsAcceptance.$dirty">
                    <b-alert
                      show
                      variant="danger"
                      class="error col mt-1"
                      v-if="!$v.termsAndConditionsAcceptance.checked"
                    >
                      Checkbox "I consent to the Terms of Use and Privacy Policy" must be checked.
                    </b-alert>
                  </div>
                </b-form-group>
                <b-button
                  type="submit"
                  class="btn send-btn mb-4 mt-2"
                  @click.prevent.stop="register"
                  >REGISTER
                </b-button>

                <div class="mt-2">
                  <a
                    class="btn btn-link"
                    @click.prevent.stop="
                      () => {
                        $router.push({ name: 'EN_SignIn' });
                      }
                    "
                    >Already registered?</a
                  >
                </div>
              </b-form>
            </div>
          </div>
        </article>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src
import {
  required,
  sameAs,
  minLength,
  numeric,
  email,
  minValue,
  maxValue,
  requiredIf
} from "vuelidate/lib/validators";
import firebase from "firebase";
import { db } from "@/main";
import Password from "vue-password-strength-meter";

export default {
  name: "EN_Register",
  components: {
    Password
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      displayName: "",
      yearOfBirth: "",
      parentsName: "",
      parentsEmail: "",
      phone: "",
      email: "",
      password: "",
      passwordRepeat: "",
      allowEmailNotifications: true,
      termsAndConditionsAcceptance: false,
      error: "",
      submitStatus: null,
      isMinor: false
    };
  },
  validations: {
    firstName: {
      required,
      minLength: minLength(3)
    },
    lastName: {
      required,
      minLength: minLength(3)
    },
    displayName: {
      required,
      minLength: minLength(3)
    },
    yearOfBirth: {
      required,
      numeric,
      minLength: minLength(4),
      minValue: minValue(1900),
      maxValue: maxValue(new Date().getFullYear())
    },
    parentsName: {
      required: requiredIf(function(val) {
        console.log("val", val);
        return val._data.isMinor;
      })
    },
    parentsEmail: {
      required: requiredIf(function(val) {
        return val._data.isMinor;
      }),
      email
    },
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(5)
    },
    passwordRepeat: {
      sameAsPassword: sameAs("password")
    },
    termsAndConditionsAcceptance: {
      checked: value => value === true
    }
  },
  beforeCreate() {
    const selectedLang = localStorage.getItem('zapisi_spomina_language');
    if(selectedLang !== null) {
      if(selectedLang === 'EN' && !this.$route.fullPath.includes('/en')) {
        this.$router.push({name: 'EN_' + this.$route.name}, this.$route.params);
      } else if(selectedLang === 'SI' && this.$route.fullPath.includes('/en')) {
        this.$router.push({name: this.$route.name.split('EN_')[1]}, this.$route.params);
      }
    }
  },
  mounted() {},
  methods: {
    async register() {
      const _this = this;
      console.log("register");

      console.log(
        "_termsAndConditionsAcceptance",
        _this.termsAndConditionsAcceptance
      );
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("this.$v.", this.$v);
        this.submitStatus = "ERROR";
        return;
      }

      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(data => {
          data.user
            .updateProfile({
              displayName: this.displayName
            })
            .then(() => {
              let ref = db.collection("users").doc();
              ref.set({ id: ref.id });

              _this.addUser(data, ref.id).then(() => {
                data.user.sendEmailVerification().then(
                  function() {
                    if (_this.isMinor) {
                      _this.sendEmailToParent().then(() => {
                        console.log("send Verification");
                        _this.$router.push({
                          name: "SignIn",
                          params: { justRegistered: "true" }
                        });
                      });
                    } else {
                      console.log("send Verification");
                      _this.$router.push({
                        name: "SignIn",
                        params: { justRegistered: "true" }
                      });
                    }
                  },
                  function(error) {
                    console.log("not send Verification", error);
                  }
                );
              });
            });
        })
        .catch(err => {
          console.log("error", err);
          if (err.code && err.code === "auth/email-already-in-use") {
            _this.error =
              "Uporabniški račun za naveden e-poštni naslov že obstaja!";
          } else {
            _this.error =
              "Registracija s posredovanimi podatki ni mogoča! Ste pravilno izpolnili vsa polja?";
          }
        });
    },

    async sendEmailToParent() {
      const _this = this;

      let subject = "Zapisi spomina: Registracija mladoletne osebe";
      let html =
        "Spoštovani,<br/>" +
        "obveščamo vas, da se je " +
        _this.firstName +
        " " +
        _this.lastName +
        " (" +
        _this.email +
        ") registriral v aplikacijo Zapisi spomina in vas navedel kot starša/skrbnika/zakonitega zastopnika.<br/><br/>To obvestilo ste prejeli, ker je v pogojih uporabe aplikacije in skladno s zakonom določeno, da morajo biti o registraciji mladoletne osebe v aplikacijo obveščeni njegovi oz. njeni starši/skrbniki/zakoniti zastopniki.<br/><br/>" +
        '<a href="https://zapisi-spomina.dobra-pot.si">Aplikacija Zapisi spomina</a> je namenjena beleženju živega ustnega izročila ljudi, zlasti starejših, in njihovih spominov o življenju nekoč. Vsebine se beležijo z namenom, da se ohranijo za danes in jutri.<br/><br/>' +
        "Če se kot skrbnik, starš oziroma zakoniti zastopnik z omenjeno registracijo mladoletne osebe ne strinjate, nam to sporočite na info@dobra-pot.si, da bomo lahko ustrezno ukrepali.<br/><br/>" +
        "Lep pozdrav,<br/>" +
        "ekipa Zavoda Dobra pot";

      console.log("Creating record for email!");
      let ref = db.collection("emails").doc();
      return ref
        .set({
          id: ref.id,
          to: _this.parentsEmail,
          message: {
            subject: subject,
            html: html
          }
        }) // set new document ID
        .then(() => {
          console.log("Record for email created!");
        });
    },

    addUser(data, id) {
      const _this = this;

      const user = db.collection("users").doc(id);

      return user
        .update({
          id: id,
          uid: data.user.uid,
          firstName: _this.firstName,
          lastName: _this.lastName,
          displayName: data.user.displayName,
          yearOfBirth: _this.yearOfBirth,
          parentsName: _this.parentsName,
          parentsEmail: _this.parentsEmail,
          phone: _this.phone,
          email: data.user.email,
          allowEmailNotifications: true,
          termsAndConditionsAcceptance: _this.termsAndConditionsAcceptance,
          createdAt: new Date(),
          updatedAt: new Date(),
          lastLoginAt: null,
        })
        .then(function() {
          console.log("Record written");
        })
        .catch(function(error) {
          console.error("Error adding Record: ", error);
        });
    },

    calculateAge() {
      const _this = this;

      if (!_this.yearOfBirth) {
        _this.isMinor = false;
        return;
      }

      let age =
        parseInt(_this.moment().format("YYYY")) - parseInt(_this.yearOfBirth);
      console.log("age", age);
      if (age > 0 && age < 18) {
        _this.isMinor = true;
      } else {
        _this.isMinor = false;
      }
    }
  }
};
</script>
